import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'documentFileType',
})
export class DocumentFileTypePipe implements PipeTransform {
  transform(fileType: string): string {
    switch (fileType) {
      case 'SUPPLIER_CONTRACT':
        return 'cockpit.documents.filterForm.fileType.supplierContract';
      case 'SUPPLIER_INVOICE':
        return 'cockpit.documents.filterForm.fileType.supplierInvoice';
      case 'ORGANIZATION_PROFILE':
        return 'cockpit.documents.filterForm.fileType.organizationProfile';
      case 'LMA_LOCATION_ANALYSIS':
        return 'cockpit.documents.filterForm.fileType.lmaLocationAnalysis';
      case 'LMA_OTHER':
        return 'cockpit.documents.filterForm.fileType.lmaOther';
      case 'LMA_BATTERY_SIMULATION':
        return 'cockpit.documents.filterForm.fileType.lmaBatterySimulation';
      case 'LMA_GRID_USAGE_OPTIMIZATION':
        return 'cockpit.documents.filterForm.fileType.lmaGridUsageOptimization';
      case 'LMA_LOAD_SIMULATION':
        return 'cockpit.documents.filterForm.fileType.lmaLoadSimulation';
      case 'UNKNOWN':
        return 'cockpit.documents.filterForm.fileType.unknown';
      default:
        return fileType;
    }
  }
}
